// In dev, use same origin so Vite proxies /api to the backend (avoids CORS and ensures correct response body).
const defaultApiBaseUrl =
  import.meta.env.VITE_DEFAULT_API_BASE_URL ??
  (import.meta.env.DEV ? '' : 'https://advoltix-backend.onrender.com');

const apiBaseUrl = import.meta.env.VITE_API_BASE_URL ?? defaultApiBaseUrl;
const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
const stripePublishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;
const appStage = (import.meta.env.VITE_APP_STAGE ?? import.meta.env.MODE ?? 'production').toLowerCase();
const isE2E = import.meta.env.VITE_E2E === 'true';

const isDev = import.meta.env.DEV;
if (!isDev) {
  if (!import.meta.env.VITE_API_BASE_URL) {
    console.warn('VITE_API_BASE_URL is not defined. API calls will fail until configured.');
  }
  if (!sentryDsn) {
    console.warn('VITE_SENTRY_DSN is not defined. Sentry will run in disabled mode.');
  }
  if (!stripePublishableKey) {
    console.warn('VITE_STRIPE_PUBLISHABLE_KEY is not defined. Stripe JS integrations will remain inactive.');
  }
  if (!import.meta.env.VITE_APP_STAGE) {
    console.warn('VITE_APP_STAGE is not defined. Defaulting to current Vite mode.');
  }
}

export const env = {
  apiBaseUrl,
  sentryDsn: sentryDsn ?? '',
  stripePublishableKey: stripePublishableKey ?? '',
  appStage,
  isE2E,
};
